import { useCustomer } from '@backpackjs/storefront';
import { Heading, Paragraph } from 'theme-ui';
import { Section } from '@snippets';
import { themed } from './LoyaltyLionTierProgress.theme';
import { Schema } from './LoyaltyLionTierProgress.schema';

export const LoyaltyLionTierProgress = themed(({ theme, cms }) => {
  const customer = useCustomer();
  const { heading, subHeading = 'Your Member Ship Status', section } = cms;
  const textAlign = [cms?.alignment, cms?.alignmentDt];

  if (!customer?.id) return null;

  return (
    <Section data-comp={LoyaltyLionTierProgress.displayName} section={section}>
      <div className="w-full flex flex-col gap-2 py-14">
        {heading && (
          <Heading
            sx={{
              ...theme.heading,
              textAlign,
            }}
            dangerouslySetInnerHTML={{
              __html: heading,
            }}
          />
        )}
        <div className="loyaltyLionTierProgress-section">
          <div className="w-full md:flex gap-6 justify-center items-center mb-2">
            <div className="max-md:text-center max-md:mb-4">
              <Paragraph
                sx={{ fontSize: 4, letterSpacing: '0.02px' }}
                dangerouslySetInnerHTML={{
                  __html: subHeading,
                }}
              />
            </div>
            <div className="flex-grow" data-lion-tier-overview />
          </div>
          <div data-lion-tier-progress="multi" />
        </div>
      </div>
    </Section>
  );
});

LoyaltyLionTierProgress.displayName = 'LoyaltyLion Tier Progress';
LoyaltyLionTierProgress.Schema = Schema;
